import React, { useState } from 'react'
import styles from './styles.module.scss'
import { useAppAccessToken } from '@/src/context/app-access-token/app-access-token-context'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import { useMessage } from '@/src/context/message/message-context'
import { useShoppingCart } from '@/src/context/shopping-cart/shopping-cart-context'
import useCoupon from '@/src/hooks/shopping-cart/useCoupon'
import { CouponService } from '@/src/services/benefits/coupon-service'
import { useTranslations } from 'next-intl'
import ActionInput from '../action-elements/action-input/action-input'
import SvgThrash from '@/src/assets/svgs/collection/trash.svg'

interface Props {
    isCheckout?: boolean
}

export default function CouponInput({ isCheckout }: Props) {
    const t = useTranslations('shopping-cart')
    const { shoppingCart, addCoupon, removeCoupon } = useShoppingCart()
    const { showMessage } = useMessage()
    const { merchantSummary } = useMerchant()
    const { validate } = useCoupon()
    const { appAccessToken } = useAppAccessToken()

    const [name, setName] = useState<string>()
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const applyCoupon = async () => {
        if (!name || (name && name.trim().length < 1))
            return showMessage('Insira o código do cupom.')

        try {
            setIsLoading(true)

            const response = await CouponService.getByName(encodeURIComponent(name), merchantSummary?.id!, appAccessToken)

            if (response.status === 404
                || !response.model
                || !response.model.coupons
                || response.model.coupons.length === 0)
                return showMessage(`Cupom ${name} inválido.`)

            if (!response.success)
                throw new Error(response.errorMessage)

            var coupon = response.model.coupons[0];

            const validation = validate(coupon)

            if (!validation.isValid)
                return showMessage(validation.message)

            addCoupon(coupon)
        }
        catch (e: any) {
            const error = e as Error
            showMessage(error.message, { type: 'danger', error: error })
        }
        finally {
            setIsLoading(false)
        }
    }

    const remove = () => {
        removeCoupon()
        setName('')
    }

    if (isCheckout && shoppingCart?.coupon?.name) {
        return (
            <ActionInput
                value={`Cupom:  ${shoppingCart?.coupon.name}`}
                disabled
                sideElement='svg'
                svg={<SvgThrash />}
                onSvgClick={remove}
                classNameContainer={styles.appliedInputArea}
            />
        )
    }

    return (
        <ActionInput
            sideElement='button'
            titleButton='Aplicar'
            placeholder={t('couponCode')}
            classNameContainer={!isCheckout ? styles.inputArea : ''}
            onButtonClick={applyCoupon}
            onChange={(e) => setName(e.target.value)}
            defaultValue={name?.toLocaleUpperCase()}
            value={name}
            onKeyDown={e => e.key === 'Enter' && applyCoupon()}
            buttonSize='small'
            isButtonLoading={isLoading}
        />
    )
}
